import { FC, memo, useCallback } from 'react'
import { CardBorderWrapper, CardContainer, Destination, Details, GuestsLabel } from './styles'
import { SearchbarHistoryItem } from '../../../redux/searchbar/types'
import { useRecentSearchCard } from './hooks'

interface Props {
    historyItem: SearchbarHistoryItem
    onSelect: (historyItem: SearchbarHistoryItem) => void
    isLoading?: boolean
}

const RecentSearchCard: FC<Props> = ({ historyItem, onSelect, isLoading = false }) => {
    const { destination, details, guestsLabel } = useRecentSearchCard(historyItem)

    const _handleClick = useCallback(() => {
        if (!isLoading) {
            onSelect(historyItem)
        }
    }, [onSelect, historyItem, isLoading])

    return (
        <CardBorderWrapper $isLoading={isLoading}>
            <CardContainer onClick={_handleClick} type="button" disabled={isLoading}>
                <Destination>{destination}</Destination>
                <Details>{details}</Details>
                <GuestsLabel>{guestsLabel}</GuestsLabel>
            </CardContainer>
        </CardBorderWrapper>
    )
}

export default memo(RecentSearchCard)
